var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10114_14299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.5 41.4C82.5 63.7741 64.1437 81.9118 41.5 81.9118C18.8563 81.9118 0.5 63.7741 0.5 41.4C0.5 19.026 18.8563 0.888184 41.5 0.888184C64.1437 0.888184 82.5 19.026 82.5 41.4Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6678 41.399C75.6678 60.044 60.3708 75.1588 41.5012 75.1588C22.6315 75.1588 7.33449 60.044 7.33449 41.399C7.33449 22.754 22.6315 7.63916 41.5012 7.63916C60.3708 7.63916 75.6678 22.754 75.6678 41.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0582 41.3997C78.0582 61.3498 61.6904 77.5228 41.4999 77.5228C21.3093 77.5228 4.94153 61.3498 4.94153 41.3997C4.94153 21.4495 21.3093 5.27661 41.4999 5.27661C61.6904 5.27661 78.0582 21.4495 78.0582 41.3997Z",
    fill: "#A50000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6678 41.399C75.6678 60.044 60.3708 75.1588 41.5012 75.1588C22.6315 75.1588 7.33449 60.044 7.33449 41.399C7.33449 22.754 22.6315 7.63916 41.5012 7.63916C60.3708 7.63916 75.6678 22.754 75.6678 41.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4931 43.3206L25.2905 33.4327L26.7331 31.137L41.5083 40.1547L60.8315 28.4287L62.2589 30.7394L41.4931 43.3206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5996 41.4008C45.5996 43.6382 43.764 45.452 41.4996 45.452C39.2352 45.452 37.3996 43.6382 37.3996 41.4008C37.3996 39.1634 39.2352 37.3496 41.4996 37.3496C43.764 37.3496 45.5996 39.1634 45.5996 41.4008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4878 14.4128L26.296 13.3813L29.223 18.3906L27.4147 19.4221L24.4878 14.4128Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0826 26.4358L14.1266 24.6491L19.1962 27.5412L18.1522 29.3279L13.0826 26.4358Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29189 40.4163H15.1458V42.4794H9.29189V40.4163Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0826 56.4656L18.1523 53.5735L19.1962 55.3602L14.1266 58.2523L13.0826 56.4656Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4903 68.4985L27.4173 63.4893L29.2255 64.5208L26.2985 69.5301L24.4903 68.4985Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.451 67.4934H42.539V73.2776H40.451V67.4934Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7679 64.5181L55.5763 63.4868L58.5024 68.4966L56.694 69.5278L53.7679 64.5181Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8006 55.3665L64.8443 53.5796L69.9144 56.4708L68.8708 58.2577L63.8006 55.3665Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8547 40.4163H73.7086V42.4794H67.8547V40.4163Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0462 27.6387L69.1391 24.7466L70.183 26.5414L65.0902 29.4335L64.0462 27.6387Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7654 18.3909L56.6924 13.3816L58.5006 14.4132L55.5736 19.4224L53.7654 18.3909Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7391 10.3638C39.4896 10.3622 39.2506 10.4627 39.0786 10.6414L37.7423 11.9542C37.3766 12.3173 37.3766 12.9041 37.7423 13.2672L41.5386 16.9807L45.3349 13.2672C45.7007 12.9041 45.7007 12.3173 45.3349 11.9542L43.9227 10.6414C43.7507 10.4627 43.5117 10.3622 43.2622 10.3638C43.011 10.3654 42.7708 10.4651 42.594 10.6414L41.5007 11.7217L40.4073 10.6414C40.2325 10.4623 39.991 10.3619 39.7391 10.3638Z",
    fill: "#CC0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10114_14299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white",
    transform: "translate(0.5 0.461182)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.60f1cbdb4929ec8bc3bba14554390cf3.svg";
export { ForwardRef as ReactComponent };